// este módulo es una mezcla de:
// https://dev.to/4unkur/how-to-use-laravel-translations-in-js-vue-files-ia
// https://github.com/rmariuzzo/Lang.js/blob/master/src/lang.js

const { default: axios } = require("axios");

let locale;

$(document).ready(function(){
    init();
});

function init(){

    locale = window._locale;

    window.init_translatable_fields = init_translatable_fields;
    init_translatable_fields();

}

export function init_translatable_fields(){

    if(typeof locale == 'undefined'){
        locale = window._locale;
    }

    $('.translations .translation:not([locale="' + locale + '"])').hide();
    $('.translations .translation[locale="' + locale + '"]').show();

    $('.translations .change_translation_locale .change_locale:not([locale="' + locale + '"])').hide();
    $('.translations .change_translation_locale .change_locale[locale="' + locale + '"]').show();

    $('.translations .change_translation_locale .change_locale')
        .unbind('click')
        .click(change_locale);

}

function change_locale(){

    for(let i=0; i<window._locales.length; i++){
        if(window._locales[i] == locale){

            locale = window._locales.length - 1 > i ? window._locales[i + 1] : window._locales[0];
            break;

        }
    }

    init_translatable_fields();

}